import { Text, Flex, Image, Button, Divider } from "@chakra-ui/react";
import { t } from "i18next";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Trans } from "react-i18next";
import { useIsSmallBreakpoint } from "../utils/useBreakpoints";
import {
  FunnelComponentProps,
  FunnelContextArea,
} from "../components/funnel/types";

export function CongratsBody({
  onSuccess,
  modalContext,
  release,
  customCongratsImage,
  customCongratsText,
}: FunnelComponentProps & {
  customCongratsImage?: string;
  customCongratsText?: string;
}) {
  const isSmall = useIsSmallBreakpoint();
  const renderCongratsText = () => {
    if (customCongratsText) {
      return customCongratsText.split("\n").map((line, index) => (
        <Text
          key={index}
          variant="onboardingTitle"
          textAlign="center"
          fontSize="24px"
        >
          {line}
        </Text>
      ));
    }
    return (
      <Text variant="onboardingTitle" textAlign="center" fontSize="24px">
        <Trans
          i18nKey="components.onboarding.splash.title"
          components={{ 1: <br /> }}
        />
      </Text>
    );
  };

  return (
    <Flex flexDirection="column" alignItems="center" width="100%" p="24px">
      <Flex mt="24px" px="24px" flexDirection="column" alignItems="center">
        {renderCongratsText()}
      </Flex>
      <Image
        src={
          customCongratsImage ??
          `${window.gc.global.assets_url}/static/images/web-ui/onboarding/onboardingSplashCovers.png`
        }
        marginTop={customCongratsImage ? 0 : "-30px"}
        width="100%"
        height="auto"
        aspectRatio={customCongratsImage ? "auto" : "512/300"}
      />
      <Flex
        marginTop="-45px"
        flexDirection="column"
        gap="24px"
        width="100%"
        px={isSmall ? "24px" : "48px"}
      >
        <Divider color="transparent.white.10" />
        <Button
          gc-testing-id="btnOnboardingStartReading"
          variant="primary"
          size="lg"
          onClick={() => {
            onSuccess({});
          }}
          width="100%"
        >
          {release?.ppb_gold_price_point
            ? t("components.onboarding.splash.continueToPurchase")
            : modalContext === FunnelContextArea.reader ||
                modalContext === FunnelContextArea.verticalReader
              ? t("components.onboarding.splash.continueReading")
              : t("components.onboarding.splash.startReading")}
        </Button>
      </Flex>
      <DotLottieReact
        src={`${window.gc.global.assets_url}/static/images/web-ui/stars_confetti.json`}
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
        autoplay
      />
    </Flex>
  );
}
